import { memo, useCallback, useState } from 'react';
import { useDrop, useDrag } from 'react-dnd';
import update from 'immutability-helper';
import customviewline from "../../../assets/icons/customviewline.svg"
import dotted from "../../../assets/icons/dotted.svg";
import { useTranslation } from "react-i18next";

const ItemTypes = {
    CARD: 'card',
}

const styleI = {
    width: 225,
};



const Card = memo(function Card({ id, text, moveCard, findCard, }) {
    const originalIndexI = findCard(id).index;
    const [{ isDragging }, drag] = useDrag({
        item: { type: ItemTypes.CARD, id, originalIndexI, },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            const { id: droppedId, originalIndex } = item;
            const didDrop = monitor.didDrop();
            if (!didDrop) {
                moveCard(droppedId, originalIndex);
            }
        },
    }, [id, originalIndexI, moveCard]);
    const [, drop] = useDrop({
        accept: ItemTypes.CARD,
        canDrop: () => false,
        hover({ id: draggedId }) {
            if (draggedId !== id) {
                const { index: overIndex } = findCard(id);
                moveCard(draggedId, overIndex);
            }
        },
    }, [findCard, moveCard]);
    const opacity = isDragging ? 0 : 1;
    return (<div ref={(node) => drag(drop(node))} className="column-button" style={{ opacity }}>
        <div className="customize-view-button-group">
            <div className="customize-view-group-1">
                <img className="customize-view-line" src={customviewline} alt="autommate-customize-view" />
                <img
                    className="customize-view-col-dotted"
                    src={dotted}
                    alt="autommate-customize-view"
                />
                <div className="customize-view-col-name">{text}</div>
            </div>
        </div>

    </div>);
});


export const ColumnItem = memo(function ColumnItem(props) {
    const { t } = useTranslation();
    const [cards, setCards] = useState(props.customColumn);
    const findCard = useCallback((id) => {
        const card = cards.filter((c) => `${c.id}` === id)[0];
        return {
            card,
            index: cards.indexOf(card),
        };
    }, [cards]);
    const moveCard = useCallback((id, atIndex) => {
        if (atIndex) {
            const { card, index } = findCard(id);
            setCards(update(cards, {
                $splice: [
                    [index, 1],
                    [atIndex, 0, card],
                ],
            }));
        }
    }, [findCard, cards, setCards]);

    function handleSave() {
        props.setCustomColumn(cards);
        props.setOpen(false);
    }

    const [, drop] = useDrop({ accept: ItemTypes.CARD });
    return (<div ref={drop} style={styleI}>
        {cards.map((card, index) => ((card.label?.length > 1 && card.options?.display !== false) && <Card key={card.id} id={`${card.id}`} text={card.label} moveCard={moveCard} findCard={findCard} />))}
        <div className="customize-view-button-group" onClick={handleSave}>
            <div className="customize-view-button-group-1">
                <div className="customize-view-apply-changes">{t('CONTENT.DATATABLE.TOOLBAR.APPLY-CHANGES')}</div>
            </div>
        </div>

    </div>);
});


